export enum EEmployeePermission {
	VIEW_AND_EXPORT_CLIENT_ORDERS = 'view_and_export_client_orders',
	IMPORT_CLIENT_ORDERS = 'import_client_orders',
	CHANGE_CLIENT_ORDER_STATUS = 'change_client_order_status',
	VIEW_CLIENT_DETAILS = 'view_client_details',
	EDIT_CLIENT_DETAILS = 'edit_client_details',
	VIEW_CLIENT_PURCHASE_DATA = 'view_client_purchase_data',
	EDIT_CLIENT_PURCHASE_DATA = 'edit_client_purchase_data',
	VIEW_CLIENT_NUTRITIONAL_DATA = 'view_client_nutritional_data',
	EDIT_CLIENT_NUTRITIONAL_DATA = 'edit_client_nutritional_data',
	VIEW_CLIENT_DIET_CALENDAR = 'view_client_diet_calendar',
	EDIT_CLIENT_DIET_CALENDAR = 'edit_client_diet_calendar',
	VIEW_CLIENT_DELIVERY_ADDRESSES = 'view_client_delivery_addresses',
	EDIT_CLIENT_DELIVERY_ADDRESSES = 'edit_client_delivery_addresses',
	VIEW_DIET_AND_MENU_DETAILS = 'view_diet_and_menu_details',
	VIEW_CLIENT_ACTIVITY = 'view_client_activity',
	VIEW_CLIENT_POINT_BALANCE = 'view_client_point_balance',
	EDIT_CLIENT_POINT_BALANCE = 'edit_client_point_balance',
	VIEW_CLIENT_POINT_HISTORY = 'view_client_point_history',
	VIEW_CLIENT_ORDERS = 'view_client_orders',
	VIEW_CLIENT_ORDER_DETAILS = 'view_client_order_details',
	EDIT_CLIENT_ORDER_DETAILS = 'edit_client_order_details',
	EXTEND_CLIENT_ORDER = 'extend_client_order',
	ADD_TRANSACTION_TO_CLIENT_ORDER = 'add_transaction_to_client_order',
	EDIT_CLIENT_ORDER_STATUS = 'edit_client_order_status',
	GENERATE_CLIENT_ORDERS = 'generate_client_orders',
	VIEW_CLIENT_TRANSACTION_LIST = 'view_client_transaction_list',
	VIEW_CLIENT_TRANSACTION_DETAILS = 'view_client_transaction_details',
	EDIT_CLIENT_TRANSACTION_DETAILS = 'edit_client_transaction_details',
	ADD_INVOICE_TO_TRANSACTION = 'add_invoice_to_transaction',
	EDIT_TRANSACTION_STATUS = 'edit_transaction_status',
	COMPLETE_TRANSACTION = 'complete_transaction',
	CANCEL_TRANSACTION = 'cancel_transaction',
	VIEW_DELIVERY_LIST = 'view_delivery_list',
	VIEW_CLIENT_ADDRESSES = 'view_client_addresses',
	ADD_AND_EDIT_CLIENT_ADDRESSES = 'add_and_edit_client_addresses',
	DELETE_CLIENT_ADDRESSES = 'delete_client_addresses',
	VIEW_CLIENT_REQUESTS = 'view_client_requests',
	REFUND_CLIENT_POINTS = 'refund_client_points',
	REJECT_CLIENT_COMPLAINTS = 'reject_client_complaints',
	CHANGE_REQUEST_STATUS = 'change_request_status',
	SEND_MESSAGE_TO_CLIENT = 'send_message_to_client',
	VIEW_CLIENT_CORRESPONDENCE_HISTORY = 'view_client_correspondence_history',
	VIEW_CLIENT_RATINGS_LIST = 'view_client_ratings_list',
	VIEW_CLIENT_RATING_DETAILS = 'view_client_rating_details',
	VIEW_LINKED_CLIENT_ACCOUNTS = 'view_linked_client_accounts',
	VIEW_LINKED_CLIENT_ACCOUNT_DETAILS = 'view_linked_client_account_details',
	VIEW_TRANSACTION_LIST = 'view_transaction_list',
	VIEW_AND_EXPORT_TRANSACTIONS = 'view_and_export_transactions',
	IMPORT_TRANSACTIONS = 'import_transactions',
	EDIT_TRANSACTION_DETAILS = 'edit_transaction_details',
	VIEW_CLIENT_LIST = 'view_client_list',
	CREATE_AND_EDIT_CLIENTS = 'create_and_edit_clients',
	DELETE_CLIENTS = 'delete_clients',
	VIEW_CLIENT_REVIEWS = 'view_client_reviews',
	HIDE_OR_DELETE_CLIENT_REVIEWS = 'hide_or_delete_client_reviews',
	VIEW_DIET_LIST = 'view_diet_list',
	VIEW_DIET_DETAILS = 'view_diet_details',
	ADD_AND_EDIT_DIETS = 'add_and_edit_diets',
	DELETE_DIETS = 'delete_diets',
	VIEW_MENU = 'view_menu',
	CREATE_AND_EDIT_MENU = 'create_and_edit_menu',
	PUBLISH_OR_REVOKE_MENU = 'publish_or_revoke_menu',
	VIEW_MEAL_LIST = 'view_meal_list',
	EDIT_MEAL_DETAILS = 'edit_meal_details',
	ADD_MEALS = 'add_meals',
	VIEW_MEAL_DETAILS = 'view_meal_details',
	VIEW_MEALPREP_LIST = 'view_mealprep_list',
	VIEW_MEALPREP_DETAILS = 'view_mealprep_details',
	ADD_AND_EDIT_MEALPREP = 'add_and_edit_mealprep',
	EDIT_MEALPREP_VARIANTS = 'edit_mealprep_variants',
	DELETE_MEALPREP = 'delete_mealprep',
	VIEW_MEALPREP_HISTORY = 'view_mealprep_history',
	VIEW_RAW_MATERIALS_LIST = 'view_raw_materials_list',
	VIEW_RAW_MATERIAL_DETAILS = 'view_raw_material_details',
	VIEW_ADDITIVES_LIST = 'view_additives_list',
	VIEW_ADDITIVE_DETAILS = 'view_additive_details',
	EDIT_ADDITIVE_DETAILS = 'edit_additive_details',
	EDIT_ADDITIVE_VARIANTS = 'edit_additive_variants',
	VIEW_POINT_ACTIONS_LIST = 'view_point_actions_list',
	MANAGE_POINT_ACTIONS = 'manage_point_actions',
	VIEW_SUPPLIERS_LIST = 'view_suppliers_list',
	ADD_AND_EDIT_SUPPLIERS = 'add_and_edit_suppliers',
	DELETE_SUPPLIERS = 'delete_suppliers',
	VIEW_SUPPLIERS = 'view_suppliers',
	VIEW_SUPPLIER_DETAILS = 'view_supplier_details',
	ADD_SUPPLIERS = 'add_suppliers',
	EDIT_AND_DELETE_SUPPLIERS = 'edit_and_delete_suppliers',
	VIEW_REGIONS_LIST = 'view_regions_list',
	VIEW_REGION_DETAILS = 'view_region_details',
	ADD_AND_EDIT_REGION = 'add_and_edit_region',
	DELETE_REGION = 'delete_region',
	VIEW_DELIVERY_SCHEDULE = 'view_delivery_schedule',
	ADD_AND_EDIT_DELIVERY_SCHEDULE = 'add_and_edit_delivery_schedule',
	DELETE_DELIVERY_SCHEDULE = 'delete_delivery_schedule',
	EDIT_CUTOFF_TIME = 'edit_cutoff_time',
	MANAGE_NON_DELIVERY_DAYS = 'manage_non_delivery_days',
	VIEW_DISTRIBUTION_CENTERS = 'view_distribution_centers',
	ADD_AND_EDIT_DISTRIBUTION_CENTERS = 'add_and_edit_distribution_centers',
	DELETE_DISTRIBUTION_CENTERS = 'delete_distribution_centers',
	VIEW_PRODUCTION_PLANTS = 'view_production_plants',
	VIEW_PRICE_LISTS = 'view_price_lists',
	EXPORT_PRICE_LISTS = 'export_price_lists',
	IMPORT_AND_EDIT_PRICE_LISTS = 'import_and_edit_price_lists',
	VIEW_DISCOUNT_CODES = 'view_discount_codes',
	VIEW_CODES_DISCOUNTS = 'view_codes_discounts',
	VIEW_DISCOUNT_CODE_DETAILS = 'view_discount_code_details',
	ADD_AND_EDIT_DISCOUNT_CODES = 'add_and_edit_discount_codes',
	DELETE_DISCOUNT_CODES = 'delete_discount_codes',
	APPROVE_DISCOUNT_CODES = 'approve_discount_codes',
	ADD_DISCOUNT_CODES_WITHOUT_APPROVAL = 'add_discount_codes_without_approval',
	VIEW_CAMPAIGNS = 'view_discount_campaigns',
	MANAGE_CAMPAIGNS = 'manage_discount_campaigns',
	APPROVE_CAMPAIGN_REQUESTS = 'approve_discount_campaigns',
	BYPASS_EDIT_CAMPAIGN_BY_NON_CREATOR = 'bypass_edit_campaign_by_non_creator',
	VIEW_CLIENT_REQUESTS_LIST = 'view_client_requests_list',
	VIEW_REQUEST_DETAILS = 'view_request_details',
	HANDLE_CLIENT_REQUESTS = 'handle_client_requests',
	VIEW_WEBINARS_AND_COURSES = 'view_webinars_and_courses',
	ADD_AND_EDIT_WEBINARS_AND_COURSES = 'add_and_edit_webinars_and_courses',
	DELETE_WEBINARS_AND_COURSES = 'delete_webinars_and_courses',
	VIEW_USER_ACCOUNTS = 'view_user_accounts',
	EDIT_USER_ACCOUNTS = 'edit_user_accounts',
	FULL_USER_PERMISSION_MANAGEMENT = 'full_user_permission_management',
	DELETE_USERS = 'delete_users',
	ADD_USERS = 'add_users',
	EDIT_ADMIN_PERMISSIONS = 'edit_admin_permissions',
	EDIT_RAW_MATERIAL_DETAILS = 'edit_raw_materials_details',
	ADD_RAW_MATERIAL_DETAILS = 'add_raw_materials_details',
	VIEW_SIZE_MATRICES = 'view_size_matrices',
	EDIT_SIZE_MATRICES = 'edit_size_matrices',
	VIEW_FRIDGE_SLOTS = 'view_fridge_slots',
	MANAGE_FRIDGE_SLOTS = 'manage_fridge_slots',
	CREATE_PURCHASE = 'create_purchase',
	VIEW_PURCHASE = 'view_purchase',
	MANAGE_PURCHASE = 'manage_purchase',
	APPROVE_PURCHASE = 'approve_purchase',
	CANCEL_PURCHASE = 'cancel_purchase',
	RECEIVE_PURCHASE = 'receive_purchase',
	CREATE_PURCHASE_ORDER = 'create_purchase_order',
	VIEW_PURCHASE_ORDER = 'view_purchase_order',
	MANAGE_PURCHASE_ORDER = 'manage_purchase_order',
	APPROVE_PURCHASE_ORDER = 'approve_purchase_order',
	CANCEL_PURCHASE_ORDER = 'cancel_purchase_order',
	RECEIVE_PURCHASE_ORDER = 'receive_purchase_order',
	MANAGE_PRODUCTION_PLAN = 'manage_production_plan',
	VIEW_PRODUCTION_PLAN = 'view_production_plan',
	VIEW_PRODUCTION_STAGES = 'view_production_stages',
	VIEW_PRODUCTION_SIMULATIONS = 'view_production_simulations',
	MANAGE_PRODUCTION_SIMULATIONS = 'manage_production_simulations',
	VIEW_PRODUCTION_SIMULATION_LOGISTIC = 'view_production_simulation_logistic',
	MANAGE_PROMARK_LABELS = 'manage_promark_labels',
	VIEW_MATERIALS_STOCK = 'view_materials_stock',
	VIEW_PRODUCTION_SIMULATION_TABLET_INSTRUCTIONS = 'view_production_simulation_tablet_instructions',
	ARCHIVE_PRODUCTION_CELLS_AND_MACHINES = 'archive_production_cells_and_machines',
	ADD_PRODUCTION_CELLS = 'add_production_cells',
	ADD_MACHINES = 'add_machines',
	EDIT_PRODUCTION_CELLS = 'edit_production_cells',
	EDIT_MACHINES = 'edit_machines',
	MES_APPROVE_PURCHASE = 'mes_approve_purchase',
	MES_CANCEL_PURCHASE = 'mes_cancel_purchase',
	MES_RECEIVE_PURCHASE = 'mes_receive_purchase',
	MES_CREATE_PURCHASE_ORDER = 'mes_create_purchase_order',
	MES_VIEW_PURCHASE_ORDER = 'mes_view_purchase_order',
	MES_MANAGE_PURCHASE_ORDER = 'mes_manage_purchase_order',
	MES_APPROVE_PURCHASE_ORDER = 'mes_approve_purchase_order',
	MES_CANCEL_PURCHASE_ORDER = 'mes_cancel_purchase_order',
	MES_RECEIVE_PURCHASE_ORDER = 'mes_receive_purchase_order',
	MES_MANAGE_PRODUCTION_PLAN = 'mes_manage_production_plan',
	MES_VIEW_PRODUCTION_PLAN = 'mes_view_production_plan',
	MES_VIEW_PRODUCTION_STAGES = 'mes_view_production_stages',
	MES_VIEW_PRODUCTION_SIMULATIONS = 'mes_view_production_simulations',
	MES_MANAGE_PRODUCTION_SIMULATIONS = 'mes_manage_production_simulations',
	MES_VIEW_PRODUCTION_SIMULATION_LOGISTIC = 'mes_view_production_simulation_logistic',
	MES_MANAGE_PROMARK_LABELS = 'mes_manage_promark_labels',
	MES_VIEW_MATERIALS_STOCK = 'mes_view_materials_stock',
	MES_VIEW_PRODUCTION_SIMULATION_TABLET_INSTRUCTIONS = 'mes_view_production_simulation_tablet_instructions',
	MES_ARCHIVE_PRODUCTION_CELLS_AND_MACHINES = 'mes_archive_production_cells_and_machines',
	MES_ADD_PRODUCTION_CELLS = 'mes_add_production_cells',
	MES_ADD_MACHINES = 'mes_add_machines',
	MES_EDIT_PRODUCTION_CELLS = 'mes_edit_production_cells',
	MES_EDIT_MACHINES = 'mes_edit_machines',
	//production-settings
	VIEW_PRODUCTION_MACHINES = 'view_production_machines',
	VIEW_PRODUCTION_MACHINE_DETAILS = 'view_production_machine_details',
	ADD_PRODUCTION_MACHINE = 'add_production_machine',
	EDIT_AND_DELETE_PRODUCTION_MACHINE = 'edit_and_delete_production_machine',
	VIEW_PRODUCTION_SOCKETS = 'view_production_sockets',
	VIEW_PRODUCTION_SOCKET_DETAILS = 'view_production_socket_details',
	ADD_PRODUCTION_SOCKETS = 'add_production_sockets',
	EDIT_AND_DELETE_PRODUCTION_SOCKETS = 'edit_and_delete_production_sockets',
	// Client
	MANAGE_INFLUENCERS = 'manage_influencers',
	IMPERSONATE = 'impersonate',
	MES_PRODUCTION_PLAN_ACCESS = 'mes_production_plan_access',
	VIEW_MES_ERROR_REPORTS = 'view_production_issues',
	CHANGE_MES_ERROR_REPORT_STATUS = 'change_production_issue_status',
	// Reports
	VIEW_ORDER_REPORTS = 'view_client_orders_report',
	// System
	MANAGE_SYSTEM = 'manage_system',
	// Gadgets - products
	VIEW_GADGETS = 'view_gadgets',
	VIEW_GADGET_DETAILS = 'view_gadget_details',
	EDIT_AND_DELETE_GADGETS = 'edit_and_delete_gadgets',
	EDIT_GADGET_POINT_PRICE_MANUALLY = 'edit_gadget_point_price_manually',
	ADD_GADGET = 'add_gadget',
	// Gadgets - warehouse
	VIEW_GADGETS_WAREHOUSES = 'view_gadgets_warehouses',
	VIEW_GADGETS_WAREHOUSE_DETAILS = 'view_gadgets_warehouse_details',
	EDIT_AND_DELETE_GADGETS_WAREHOUSES = 'edit_and_delete_gadgets_warehouses',
	ADD_GADGETS_WAREHOUSE = 'add_gadgets_warehouse',
	// Gadgets - warehouse status
	VIEW_GADGETS_WAREHOUSE_STATUS = 'view_gadgets_warehouse_status',
	VIEW_GADGETS_WAREHOUSE_STATUS_DETAILS = 'view_gadgets_warehouse_status_details',
	EDIT_AND_DELETE_GADGETS_WAREHOUSE_STATUS = 'edit_and_delete_gadgets_warehouse_status',
	ADD_GADGETS_WAREHOUSE_STATUS = 'add_gadgets_warehouse_status',
	// Gadgets - boxes
	VIEW_GADGETS_BOXES = 'view_gadgets_boxes',
	VIEW_GADGET_BOX_DETAILS = 'view_gadget_box_details',
	EDIT_AND_DELETE_GADGETS_BOXES = 'edit_and_delete_gadgets_boxes',
	ADD_GADGETS_BOX = 'add_gadgets_box',
	// Gadgets - orders
	VIEW_GADGETS_ORDERS = 'view_gadgets_orders',
	VIEW_GADGET_ORDER_DETAILS = 'view_gadget_order_details',
	EDIT_GADGETS_ORDERS = 'edit_gadgets_orders',
	// External orders
	MANAGE_EXTERNAL_ORDERS = 'manage_external_orders',
	// Lost carts
	VIEW_LOST_CARTS = 'view_lost_carts',
	// Facilities
	MANAGE_FACILITIES = 'manage_facilities',
	// Wallets
	MANAGE_TOP_UP_WALLETS = 'manage_top_up_wallets',
	MANAGE_CASHBACK_WALLETS = 'manage_cashback_wallets',
	// Internal orders
	MANAGE_INTERNAL_ORDERS = 'manage_internal_orders',
	MANAGE_INTERNAL_ORDER_PURPOSE_EVENT_SAMPLE = 'manage_internal_order_purpose_event_sample',
	MANAGE_INTERNAL_ORDER_PURPOSE_TASTING_PANEL = 'manage_internal_order_purpose_tasting_panel',
	MANAGE_INTERNAL_ORDER_PURPOSE_OTHER = 'manage_internal_order_purpose_other',
	MANAGE_INTERNAL_ORDER_PURPOSE_FOOD_TRUCK = 'manage_internal_order_purpose_food_truck',
	// Newsletter
	VIEW_NEWSLETTER = 'view_newsletter',
	MANAGE_NEWSLETTER = 'manage_newsletter',
	MANAGE_PROMO_WALLET = 'manage_promo_wallet',
	MANAGE_WALLET_LIMITS = 'manage_wallet_limits',
}
